module.exports = __webpack_public_path__ + "img/About_Employers_DARK-01.1729df9.svg";